import * as React from 'react';
import { styled } from 'styled-components';
import { signUpPageUrl } from '../../../core/constants';
import FormButtons from '../common/FormButton';
import { appHeaderWrapperHeightV2, globalHeaderZIndex, tabletPortraitMinWidth } from '../../cssConstants';
import kellyPartnersLogoBlueSvg from '../../../images/kellyPartnersLogoBlue.svg';
import AutoLogoutLayout from '../common/Layout';
import Helmet from '../../../commonComponents/Helmet';
import { useNavigateWithAppName } from '../../common/NavigateWithAppName';

const InitialSubLoginPage = ({ onLoginButtonClick }: Props) => {
	const navigate = useNavigateWithAppName();

	const handleCreateAccountButtonClick = () => {
		navigate(signUpPageUrl);
	};

	return (
		<AutoLogoutLayout onBackButtonClick={null} showHeader={false} showFooter>
			<Helmet>
				<title>Initial Login</title>
			</Helmet>
			<LoginContainer>
				<StyledLoginContainer>
					<HeaderWrapper>
						<HeaderLogo src={kellyPartnersLogoBlueSvg} alt="Kelly+Partners Logo" />
					</HeaderWrapper>
					<FormButtons
						onOtherButtonClick={handleCreateAccountButtonClick}
						otherButtonText="Create an account"
						onContinueButtonClick={onLoginButtonClick}
						continueButtonText="Login"
					/>
				</StyledLoginContainer>
			</LoginContainer>
		</AutoLogoutLayout>
	);
};

export default InitialSubLoginPage;

interface Props {
	onLoginButtonClick?: () => void;
}

const HeaderWrapper = styled.section`
	top: 0;
	width: 100%;
	z-index: ${globalHeaderZIndex};
	text-align: center;
`;

const HeaderLogo = styled.img`
	height: auto;
	width: 280px;

	@media (min-width: ${tabletPortraitMinWidth}) {
		width: 500px;
	}
`;

const LoginContainer = styled.div`
	display: flex;
	padding-top: ${appHeaderWrapperHeightV2};
	height: calc(100vh - 110px - 150px - 16px);
`;

const StyledLoginContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
`;
